import { render, staticRenderFns } from "./AssistantCatHomeLoading.vue?vue&type=template&id=27233c0b&scoped=true"
import script from "./AssistantCatHomeLoading.vue?vue&type=script&lang=ts"
export * from "./AssistantCatHomeLoading.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatHomeLoading.vue?vue&type=style&index=0&id=27233c0b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27233c0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27233c0b')) {
      api.createRecord('27233c0b', component.options)
    } else {
      api.reload('27233c0b', component.options)
    }
    module.hot.accept("./AssistantCatHomeLoading.vue?vue&type=template&id=27233c0b&scoped=true", function () {
      api.rerender('27233c0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/assistantCatHome/AssistantCatHomeLoading.vue"
export default component.exports